import { useRef, useState } from "react";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useContextParcelas } from "src/Contexts/Parcelas/ParcelasContext";
import { api } from "src/shared/setup/API/api";

interface IHandleUpdateStatusContratos {
  setStep: (step: number) => void;
}

export const UseFormUploadImportInstallments = ({
  setStep,
}: IHandleUpdateStatusContratos) => {
  const { setAttTable } = useConfigPageContext();
  const { handleGetAlert } = useLayoutMainContext();
  const { filesUploadImportInstallments, setListUploadInstallments } = useContextParcelas();

  const [loading, setLoading] = useState(false);
  const abortControllerRef = useRef<AbortController | null>(null);

  const handleUploadCommission = async () => {
    if (!filesUploadImportInstallments.data) {
      return handleGetAlert({ message: "Enviar uma data de pagamento" });
    }
    if (!filesUploadImportInstallments.file.pdf) {
      return handleGetAlert({ message: "Enviar um arquivo" });
    }
    if (!filesUploadImportInstallments.operadora_id) {
      return handleGetAlert({ message: "Enviar uma operadora" });
    }

    // Cria novo AbortController para esta requisição
    abortControllerRef.current = new AbortController();

    setLoading(true);

    const data = new FormData();

    const fileBlob = new Blob([filesUploadImportInstallments.file.pdf], {
      type: filesUploadImportInstallments.file.type,
    });

    data.append("file", fileBlob, filesUploadImportInstallments.file.name);
    data.append("data_pagamento", filesUploadImportInstallments.data);
    data.append("operadora_id", filesUploadImportInstallments.operadora_id);

    return api
      .post(`/bordero/analiseParcelasUpload`, data, {
        signal: abortControllerRef.current.signal,
      })
      .then((res) => {
        handleGetAlert({ message: res.data.message });
        setAttTable((item) => !item);
        setStep(2);
        setListUploadInstallments(res.data);
      })
      .catch((error) => {
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          handleGetAlert({ message: "Análise cancelada pelo usuário" });
        } else {
          handleGetAlert({ message: error.response?.data?.message || "Erro ao processar arquivo" });
        }
      })
      .finally(() => {
        setLoading(false);
        abortControllerRef.current = null;
      });
  };

  const handleCancelUpload = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
  };

  return { handleUploadCommission, handleCancelUpload, loading };
};
